var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_c('div',{staticClass:"empty-image"},[_c('img',{attrs:{"src":_vm.imageSrc,"alt":_vm.description}})]),_c('div',{staticClass:"empty-text"},[_c('div',{staticClass:"empty-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('div',{staticClass:"empty-description"},[_vm._v(_vm._s(_vm.description))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }